import React from 'react';
import { Button } from 'reactstrap';

const TableActionButton = props => {
  return (
    <div className="d-flex">
        {props.view.active && 
            <Button
                data-toggle="tooltip"
                title="View"
                className="theme-button theme-button-secondary mr-2"
                onClick={() => props.view.action()}
            >
                View
            </Button>
        }

        {props.edit.active && 
            <Button
                data-toggle="tooltip"
                title="Edit"
                className="theme-button theme-button-secondary mr-2"
                onClick={() => props.edit.action()}
            >
                Edit
            </Button>
        }

        {props.delete.active && 
            <Button
                data-toggle="tooltip"
                title="Delete"
                className="theme-button theme-button-primary-light mr-2"
                onClick={() => props.delete.action()}
            >
                Delete
            </Button>
        }

        {props.custom.active && 
            <Button
                data-toggle="tooltip"
                title="Billing"
                className="theme-button theme-button-dark mr-2"
                onClick={() => props.custom.action()}
            >
                Billing
            </Button>
        }
    </div>
  );
};

export default TableActionButton;
